<template>
  <div class="card card-body rounded-top">
    <component-table
      entityType="profile"
      :columns="columns"
      :actions="actions"
      :data="list"
      :total="count"
      :hideAddButton="true"
      :hideSearchInput="true"
      @delete="showDeleteDialog($event.id)"
      @view="showContentModal($event.clubName, $event.content)"
    />

    <preview-modal
      :show="previewModal"
      :text="previewModalText"
      :title="previewModalTitle"
      @close="closeContentModal"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import PreviewModal from '@/components/modals/PreviewModal';
import ComponentTable from '@/components/table/Table';
import { listMixin } from '@/mixins/list';
import { DELETE_ACTION, VIEW_ACTION } from '@/utils/constants';
import { OfferTypeListTranslation, OfferType } from '@/enums/offerType.enum';
import previewModalMixin from '@/mixins/previewModal.mixin';
import { getProfileId } from '@/utils';

// @vuese
// Wnioski użytkownika
// @group Profile
export default {
  mixins: [
    listMixin('profile/offers', {
      deleteConfirm: 'messages.offer.deleteConfirm',
      deleted: 'messages.offer.deleted',
      deleteError: 'messages.offer.deleteError'
    }),
    previewModalMixin
  ],
  components: { ComponentTable, PreviewModal },
  data() {
    return {
      columns: [{ name: 'clubName', displayName: 'columns.clubName' }, { name: 'type', displayName: 'columns.type' }],
      actions: [
        {
          ...VIEW_ACTION,
          icon: 'fal fa-fw fa-search',
          permissions: ['OFFER.GET'],
          entityId: getProfileId()
        },
        { ...DELETE_ACTION, permissions: ['OFFER.DELETE'], entityId: getProfileId() }
      ]
    };
  },
  computed: {
    ...mapState({
      list: state =>
        state.profile.offers.list.map(item => ({
          ...item,
          clubName: item.club.name,
          type: OfferTypeListTranslation[OfferType[item.type]]
        })),
      count: state => state.profile.offers.count
    })
  }
};
</script>